import { render, staticRenderFns } from "./SearchInput.vue?vue&type=template&id=58544bf0&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"
import style0 from "./SearchInput.vue?vue&type=style&index=0&id=58544bf0&prod&scoped=true&lang=css"
import style1 from "./SearchInput.vue?vue&type=style&index=1&id=58544bf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58544bf0",
  null
  
)

export default component.exports